import {
  Accordion,
  AccordionItem,
  Group,
  SegmentedControl,
  Stack,
  Text,
  ThemeIcon,
  Title,
} from "@mantine/core";
import { IconSend } from "@tabler/icons-react";
import ReportingInfo from "../ReportingInfo";
import { useMemo, useState } from "react";
import ReportingSendersAll from "./ReportingSendersAll";
import ReportingSendersDate from "./ReportingSendersDate";
import { useLanguage } from "../../../../stores/LanguageStore";

const ReportingSenders = () => {
  const lang = useLanguage((s) => s.language);
  const [active, setActive] = useState("all");

  const component = useMemo(() => {
    if (active === "all") {
      return <ReportingSendersAll />;
    }
    return <ReportingSendersDate />;
  }, [active]);

  return (
    <Accordion variant="contained" radius={"md"} defaultValue={"activity"}>
      <AccordionItem value="activity" style={{ border: 0 }}>
        <Accordion.Control bg={"primary.0"}>
          <Group>
            <ThemeIcon
              variant="filled"
              radius={"md"}
              size={"lg"}
              color={"var(--mantine-color-primary-6)"}
            >
              <IconSend />
            </ThemeIcon>

            <Title order={3} fw={500}>
              {lang.reports.senders_title}
            </Title>

            <ReportingInfo>
              <Text>{lang.reports.senders_title_text}</Text>
            </ReportingInfo>
          </Group>
        </Accordion.Control>

        <Accordion.Panel bg={"var(--mantine-color-primary-2)"}>
          <Stack align="center" pt={8}>
            <SegmentedControl
              data={[
                {
                  label: lang.reports.delivrability_title,
                  value: "all",
                },
                {
                  label: lang.reports.senders_date_title,
                  value: "date",
                },
              ]}
              value={active}
              onChange={setActive}
              size="lg"
            />

            {component}
          </Stack>
        </Accordion.Panel>
      </AccordionItem>
    </Accordion>
  );
};

export default ReportingSenders;
